import React, { useEffect, useState } from "react";
import { Box, Button, Paper, Typography, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { toast } from "react-toastify";
import api from 'api/axios';
import Listtable from 'components/common/ListTable';
import ModalScreen from 'components/common/Modal';
import SubscriptionCard from "../SubscriptionCard/SubscriptionCard";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import { useOutletContext } from "react-router-dom";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Tooltip } from "@mui/material";
import JoinedDoctorsModal from "./JoinedDoctorsModal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  getSubscriptionPlans as fetchSubscriptionPlans,
  updateSubscriptionPlan as patchSubscriptionPlan,
} from "api/subscriptionPlans";
import {
  getSignupKeys,
  generateSignupKey,
  updateSignupKeyLimit,
  deleteSignupKey,
} from "api/signupKeys";

const tableHeader = ["Specialization", "Number of Doctor's", "Action"];
const tableHeader2 = ["Education", "Number of Doctor's", "Action"];
const keysName = ["name", "docCount", "action"]; 
const keysName2 = ["name", "docCount", "action"];
const tableHeader3 = [
  "Key",
  "Issued To",
  "Usage (Used/Total)",
  "Created On",
  "Action",
];
const keysName3 = ["key", "issuedName", "usageStatus", "createdAt", "action"];
const tableHeader4 = ["Frequency", "Action"];
const keysName4 = ["name", "action"];
const tableHeader5 = ["Drug Type", "Action"];
const keysName5 = ["name", "action"];
const btnStyle = {
  padding: "0.5rem 2rem",
  color: "#194AF5",
  bgcolor: "#E6EBFF",
  boxShadow: "none",
  borderRadius: "8px",
  ":hover": {
    bgcolor: "#E6EBFF",
    color: "#194AF5",
    boxShadow: "none",
  },
};

function Settings() {
  const [activeTab, setActiveTab] = useState("Subscriptions");
  const [specialization, setSpecialization] = useState([]);
  const [education, setEducation] = useState([]);
  const [frequency, setFrequency] = useState([]);
  const [drugTypes, setDrugTypes] = useState([]);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [updatedsubscriptionPlans, setUpdatedSubscriptionPlans] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [confirmOpenModal, setconfirmOpenModal] = useState(false);
  const [data, setData] = useState({});
  const [disabled, setDisabled] = useState(true);
  const { searchText } = useOutletContext();
  const [list, setList] = useState([]);
  const [maxUsage, setMaxUsage] = useState(5);
  const [generatedKey, setGeneratedKey] = useState("");
  const [issuedName, setIssuedName] = useState("");
  const [loadingKey, setLoadingKey] = useState(false);
  const [doctorKeys, setDoctorKeys] = useState([]);
  const [openDoctorKeyModal, setOpenDoctorKeyModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editMaxUsage, setEditMaxUsage] = useState("");
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [joinedDocsOpen, setJoinedDocsOpen] = useState(false);
  useEffect(() => {
    const data = list?.filter((x) =>
      x?.name?.toLowerCase()?.includes(searchText.toLowerCase())
    );
    setSpecialization(data);
  }, [searchText, list]);

  const getSpecialization = (e) => {
    const PayLoad = {
      ...(e &&
        e.target.value && {
          text: e.target.value,
        }),
    };
    const url = e
      ? `/specialization/doctor-count?text=${e?.target?.value}`
      : `/specialization/doctor-count`;

    api
      .get(url, PayLoad)
      .then((res) => {
        if (res && res.data?.data?.Specialization) {
          const formattedData = res.data.data.Specialization.map((item) => ({
            ...item,
            action: (
              <IconButton onClick={() => handleModal(item)}>
                <EditIcon fontSize="small" color="primary" />
              </IconButton>
            ),
          }));
          setSpecialization(formattedData);
          setList(formattedData);
        }
      })
      .catch((err) => {
        toast.error("Error " + err);
      });
  };

  const getEducation = (e) => {
    const PayLoad = {
      ...(e &&
        e.target.value && {
          text: e.target.value,
        }),
    };
    const url = e
      ? `/education/doctor-count?text=${e?.target?.value}`
      : `/education/doctor-count`;

    api
      .get(url, PayLoad)
      .then((res) => {
        if (res && res.data?.data?.educations) {
          const formattedData = res.data.data.educations.map((item) => ({
            ...item,
            action: (
              <IconButton onClick={() => handleModal(item)}>
                <EditIcon fontSize="small" color="primary" />
              </IconButton>
            ),
          }));
          setEducation(formattedData);
        }
      })
      .catch((err) => {
        toast.error("Error " + err);
      });
  };

  // Frequency (DosesType) is the master list behind the prescription and IPD
  // frequency dropdowns in drcfo.frontend.
  const getFrequency = () => {
    api
      .get(`/doses_type`)
      .then((res) => {
        if (res && res.data?.data?.DosesTypes) {
          const formattedData = res.data.data.DosesTypes.map((item) => ({
            ...item,
            action: (
              <IconButton onClick={() => handleModal(item)}>
                <EditIcon fontSize="small" color="primary" />
              </IconButton>
            ),
          }));
          setFrequency(formattedData);
        }
      })
      .catch((err) => {
        toast.error("Error " + err);
      });
  };

  const getDrugTypes = () => {
    api
      .get(`/drug_type`)
      .then((res) => {
        if (res && res.data?.data?.DrugTypes) {
          const formattedData = res.data.data.DrugTypes.map((item) => ({
            ...item,
            action: (
              <IconButton onClick={() => handleModal(item)}>
                <EditIcon fontSize="small" color="primary" />
              </IconButton>
            ),
          }));
          setDrugTypes(formattedData);
        }
      })
      .catch((err) => {
        toast.error("Error " + err);
      });
  };

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditClick = () => {
    setEditMaxUsage(selectedRow.maxUsage);
    setOpenEditModal(true);
    handleMenuClose();
  };

  const handleDeleteClick = () => {
    setDeleteConfirmOpen(true);
    handleMenuClose();
  };

  const handleConfirmDelete = async () => {
    const res = await deleteSignupKey(selectedRow._id);
    if (res?.status === 200) {
      toast.success("Key deleted successfully");
      setDeleteConfirmOpen(false);
      getDoctorKeys();
    } else {
      toast.error("Failed to delete key");
    }
  };

  const enableBtn = () => {
    setDisabled(false);
  };

  const getSubscriptionPlans = async (e) => {
    const res = await fetchSubscriptionPlans(e?.target?.value);
    if (res?.status === 200) {
      setSubscriptionPlans(res?.data?.data?.plans);
    } else {
      toast.error("Could not load subscription plans");
    }
  };

  const UpdateSubscriptionPlan = async () => {
    const updates = Object.keys(updatedsubscriptionPlans).map((id) =>
      patchSubscriptionPlan(id, updatedsubscriptionPlans[id])
    );

    const results = await Promise.all(updates);
    if (results.every((res) => res?.status === 200)) {
      toast.success("Updated Plans Successfully");
    } else {
      toast.error("Could not update all plans");
    }
    getSubscriptionPlans();
  };

  const handleUpdateLimit = async () => {
    if (editMaxUsage < selectedRow.usedCount) {
      toast.error(`Limit cannot be less than current usage (${selectedRow.usedCount})`);
      return;
    }

    const res = await updateSignupKeyLimit(selectedRow._id, editMaxUsage);
    if (res?.status === 200) {
      toast.success("Limit updated successfully");
      setOpenEditModal(false);
      getDoctorKeys();
    } else {
      toast.error("Failed to update limit");
    }
  };
  
  const getDoctorKeys = async () => {
    const res = await getSignupKeys();
    if (res?.status === 200) {
      const formattedData = (res.data.data || []).map(item => ({
        ...item,
        key: (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography sx={{ fontFamily: "monospace", fontWeight: "bold" }}>
              {item.key}
            </Typography>
            <Tooltip title="Copy Key">
              <IconButton
                size="small"
                onClick={() => {
                  navigator.clipboard.writeText(item.key);
                  toast.success("Key copied to clipboard!");
                }}
                sx={{ color: "#194AF5" }}
              >
                <ContentCopyIcon sx={{ fontSize: "16px" }} />
              </IconButton>
            </Tooltip>
          </Box>
        ),
        usageStatus: (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                {item.usedCount} / {item.maxUsage}
              </Typography>
              <Tooltip title={item.usedCount > 0 ? "View Joined Doctors" : "No doctors joined yet"}>
                <span>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setSelectedRow(item);
                      setJoinedDocsOpen(true);
                    }}
                    disabled={item.usedCount === 0}
                    sx={{
                      color: "#194AF5",
                      bgcolor: "#E6EBFF",
                      "&:hover": { bgcolor: "#D0D9FF" },
                      padding: "4px"
                    }}
                  >
                    <VisibilityIcon sx={{ fontSize: "18px" }} />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
          ),
          action: (
            <IconButton onClick={(e) => handleMenuOpen(e, item)}>
              <MoreVertIcon />
            </IconButton>
          )
        }));
      setDoctorKeys(formattedData);
    }
  };

  useEffect(() => {
    getSpecialization();
    getSubscriptionPlans();
    getEducation();
  }, []);

  useEffect(() => {
    if (activeTab === "DoctorKeys") {
      getDoctorKeys();
    }
    if (activeTab === "Frequency") {
      getFrequency();
    }
    if (activeTab === "DrugTypes") {
      getDrugTypes();
    }
  }, [activeTab]);

  const generateDoctorKey = async () => {
    if (!issuedName.trim()) {
      toast.error("Please enter issued name");
      return;
    }

    setLoadingKey(true);
    const res = await generateSignupKey({ maxUsage, issuedName });
    setLoadingKey(false);

    if (res?.status === 201) {
      setGeneratedKey(res.data.data.key);
      toast.success("Signup key generated successfully");
      getDoctorKeys();
    } else {
      toast.error("Failed to generate signup key");
    }
  };

  const handleModal = (e) => {
    setData(e);
    setOpenModal(true);
  };

  const handleModalClose = (buttonText = "save") => {
    setData({});
    if (buttonText !== "close") {
      getSpecialization();
      getEducation();
      getFrequency();
      getDrugTypes();
    }
    setOpenModal(false);
  };

  const handleCloseDoctorKeyModal = () => {
    setOpenDoctorKeyModal(false);
    setGeneratedKey("");
    setIssuedName("");
    setMaxUsage(5);
  };

  useEffect(() => {
    getSpecialization();
    getSubscriptionPlans();
    getEducation();
  }, []);

  useEffect(() => {
    if (activeTab === "Subscriptions") {
      getSubscriptionPlans();
    }
  }, [activeTab]);

  const handleSave = () => {
    UpdateSubscriptionPlan();
    setDisabled(true);
  };

  return (
    <Box sx={{ margin: "1rem" }}>
      <Paper sx={{ padding: "1rem", boxShadow: "none" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mr: "auto",
            }}
          >
            <Box
              onClick={() => {
                setActiveTab("Subscriptions");
              }}
              sx={{
                borderBottom:
                  activeTab === "Subscriptions"
                    ? "2px solid #194AF5"
                    : "2px solid transparent",
                color: activeTab === "Subscriptions" ? "#194AF5" : "#7D8DC4",
                width: "max-content",
                padding: "0.5rem 1rem",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Subscriptions
            </Box>
            <Box
              onClick={() => {
                setActiveTab("Specialization");
              }}
              sx={{
                borderBottom:
                  activeTab === "Specialization"
                    ? "2px solid #194AF5"
                    : "2px solid transparent",
                  color: activeTab === "Specialization" ? "#194AF5" : "#7D8DC4",
                padding: "0.5rem 1rem",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Specialization
            </Box>

            <Box
              onClick={() => setActiveTab("Education")}
              sx={{
                borderBottom:
                  activeTab === "Education"
                    ? "2px solid #194AF5"
                    : "2px solid transparent",
                color: activeTab === "Education" ? "#194AF5" : "#7D8DC4",
                padding: "0.5rem 1rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Education
            </Box>

            <Box
              onClick={() => setActiveTab("Frequency")}
              sx={{
                borderBottom:
                  activeTab === "Frequency"
                    ? "2px solid #194AF5"
                    : "2px solid transparent",
                color: activeTab === "Frequency" ? "#194AF5" : "#7D8DC4",
                width: "max-content",
                padding: "0.5rem 1rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Frequency
            </Box>

            <Box
              onClick={() => setActiveTab("DrugTypes")}
              sx={{
                borderBottom:
                  activeTab === "DrugTypes"
                    ? "2px solid #194AF5"
                    : "2px solid transparent",
                color: activeTab === "DrugTypes" ? "#194AF5" : "#7D8DC4",
                width: "max-content",
                padding: "0.5rem 1rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Drug Types
            </Box>

            <Box
              onClick={() => {
                setActiveTab("DoctorKeys");
              }}
              sx={{
                borderBottom:
                  activeTab === "DoctorKeys"
                    ? "2px solid #194AF5"
                    : "2px solid transparent",
                color: activeTab === "DoctorKeys" ? "#194AF5" : "#7D8DC4",
                width: "max-content",
                padding: "0.5rem 1rem",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Doctor Signup Keys
            </Box>
          </Box>
          <Button
            sx={{
              ...btnStyle,
              bgcolor: "#194AF5",
              color: "white",
              width: "max-content",
              ":hover": {},
              display: activeTab === "Specialization" ? "block" : "none",
            }}
            variant="contained"
            fullWidth
            onClick={() => handleModal({})}
          >
            Add Specialization
          </Button>
          <Button
            sx={{
              ...btnStyle,
              bgcolor: "#194AF5",
              color: "white",
              width: "max-content",
              ":hover": {},
              display: activeTab === "Education" ? "block" : "none",
            }}
            variant="contained"
            fullWidth
            onClick={() => handleModal({})}
          >
            Add Education
          </Button>
          <Button
            sx={{
              ...btnStyle,
              bgcolor: "#194AF5",
              color: "white",
              width: "max-content",
              ":hover": {},
              display: activeTab === "Frequency" ? "block" : "none",
            }}
            variant="contained"
            fullWidth
            onClick={() => handleModal({})}
          >
            Add Frequency
          </Button>
          <Button
            sx={{
              ...btnStyle,
              bgcolor: "#194AF5",
              color: "white",
              width: "max-content",
              ":hover": {},
              display: activeTab === "DrugTypes" ? "block" : "none",
            }}
            variant="contained"
            fullWidth
            onClick={() => handleModal({})}
          >
            Add Drug Type
          </Button>
          <Button
            sx={{
              ...btnStyle,
              bgcolor: "#194AF5",
              color: "white",
              width: "max-content",
              display: activeTab === "DoctorKeys" ? "block" : "none",
            }}
            variant="contained"
            onClick={() => setOpenDoctorKeyModal(true)}
          >
            Add Doctor Signup Key
          </Button>
        </Box>
        {activeTab === "Specialization" ? (
          <Box
            sx={{
              margin: "1rem 0",
              padding: "1rem",
              border: "1px solid #DDDDDD",
              borderRadius: "8px",
            }}
          >
            <Typography sx={{ fontWeight: "600", fontSize: "20px" }}>
              List of Specialization
            </Typography>
            <Listtable
              tableheader={tableHeader}
              tablebody={specialization}
              dataKeyName={keysName}
              editHandle={handleModal}
              tag={activeTab}
            />
            {openModal && (
              <ModalScreen
                open={openModal}
                onClose={handleModalClose}
                data={data}
                type={activeTab}
              />
            )}
          </Box>
        ) : activeTab === "Education" ? (
          <Box
            sx={{
              margin: "1rem 0",
              padding: "1rem",
              border: "1px solid #DDDDDD",
              borderRadius: "8px",
            }}
          >
            <Typography sx={{ fontWeight: "600", fontSize: "20px" }}>
              List of Education
            </Typography>
            <Listtable
              tableheader={tableHeader2}
              tablebody={education}
              dataKeyName={keysName2}
              editHandle={handleModal}
              tag={activeTab}
            />
            {openModal && (
              <ModalScreen
                open={openModal}
                onClose={handleModalClose}
                data={data}
                type={activeTab}
              />
            )}
          </Box>
        ) : activeTab === "Frequency" ? (
          <Box
            sx={{
              margin: "1rem 0",
              padding: "1rem",
              border: "1px solid #DDDDDD",
              borderRadius: "8px",
            }}
          >
            <Typography sx={{ fontWeight: "600", fontSize: "20px" }}>
              List of Frequency
            </Typography>
            <Listtable
              tableheader={tableHeader4}
              tablebody={frequency}
              dataKeyName={keysName4}
              editHandle={handleModal}
              tag={activeTab}
            />
            {openModal && (
              <ModalScreen
                open={openModal}
                onClose={handleModalClose}
                data={data}
                type={activeTab}
              />
            )}
          </Box>
        ) : activeTab === "DrugTypes" ? (
          <Box
            sx={{
              margin: "1rem 0",
              padding: "1rem",
              border: "1px solid #DDDDDD",
              borderRadius: "8px",
            }}
          >
            <Typography sx={{ fontWeight: "600", fontSize: "20px" }}>
              List of Drug Types
            </Typography>
            <Listtable
              tableheader={tableHeader5}
              tablebody={drugTypes}
              dataKeyName={keysName5}
              editHandle={handleModal}
              tag={activeTab}
            />
            {openModal && (
              <ModalScreen
                open={openModal}
                onClose={handleModalClose}
                data={data}
                type={activeTab}
              />
            )}
          </Box>
        ) : activeTab === "DoctorKeys" ? (
          <Box
            sx={{
              margin: "1rem 0",
              padding: "1rem",
              border: "1px solid #DDDDDD",
              borderRadius: "8px",
            }}
          >
            <Typography sx={{ fontWeight: "600", fontSize: "20px" }}>
             LIST OF DOCTOR SIGNUP KEYS
            </Typography>

            <Listtable
              tableheader={tableHeader3}
              tablebody={doctorKeys}
              dataKeyName={keysName3}
              tag="DoctorKeys" 
            />
          </Box>
        ) : (
          <Box
            sx={{
              margin: "1rem 0",
              padding: "1rem",
              borderRadius: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: "1rem",
              }}
            >
              {subscriptionPlans &&
                subscriptionPlans.map((item, index) => (
                  <SubscriptionCard
                    key={item._id}
                    data={item}
                    enableBtn={enableBtn}
                    setPlansToUpdate={(id, updatedData) =>
                      setUpdatedSubscriptionPlans((prev) => ({
                        ...prev,
                        [id]: updatedData,
                      }))
                    }
                  />
                ))}
            </Box>
          </Box>
        )}
            <Box
              sx={{
                width: "100%",
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              {activeTab === "Subscriptions" && (
                <Button
                  variant="contained"
                  disabled={disabled}
                  onClick={() => setconfirmOpenModal(true)}
                  sx={{
                    ...btnStyle,
                    bgcolor: disabled ? "#B9C5F2" : "#194AF5",
                    color: "white",
                    width: "max-content",
                    ":hover": { bgcolor: disabled ? "#B9C5F2" : "#1540d6" },
                  }}
                >
                  Save Changes
                </Button>
              )}
        </Box>
      </Paper>

      <Dialog 
        open={openDoctorKeyModal} 
        onClose={handleCloseDoctorKeyModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Generate Doctor Signup Key</DialogTitle>
        <DialogContent>
          {generatedKey ? (
            <Box sx={{ pt: 2 }}>
              <Typography sx={{ fontSize: "14px", mb: 1, color: "#626262" }}>
                Copy this key now — for security it is stored hashed and cannot be
                shown again.
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  bgcolor: "#F2F5FF",
                  borderRadius: "6px",
                  p: 1.5,
                  mb: 2,
                }}
              >
                <Typography
                  sx={{ fontFamily: "monospace", fontWeight: "bold", flex: 1 }}
                >
                  {generatedKey}
                </Typography>
                <Tooltip title="Copy Key">
                  <IconButton
                    size="small"
                    onClick={() => {
                      navigator.clipboard.writeText(generatedKey);
                      toast.success("Key copied to clipboard!");
                    }}
                    sx={{ color: "#194AF5" }}
                  >
                    <ContentCopyIcon sx={{ fontSize: "18px" }} />
                  </IconButton>
                </Tooltip>
              </Box>
              <Button
                variant="contained"
                onClick={handleCloseDoctorKeyModal}
                fullWidth
                sx={{ mb: 2 }}
              >
                Done
              </Button>
            </Box>
          ) : (
            <Box sx={{ pt: 2 }}>
              <Typography sx={{ fontSize: "14px", mb: 0.5, fontWeight: 500 }}>
                Issued To (Name)
              </Typography>
              <input
                type="text"
                value={issuedName}
                onChange={(e) => setIssuedName(e.target.value)}
                placeholder="Enter name"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  marginBottom: "1rem",
                  fontSize: "14px",
                }}
              />

              <Typography sx={{ fontSize: "14px", mb: 0.5, fontWeight: 500 }}>
                Max Doctors Allowed
              </Typography>
              <input
                type="number"
                value={maxUsage}
                onChange={(e) => {
                  const val = e.target.value;
                  setMaxUsage(val === "" ? "" : Number(val));
                }}
                min="1"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  marginBottom: "1rem",
                  fontSize: "14px",
                }}
              />
              <Button
                variant="contained"
                onClick={generateDoctorKey}
                disabled={loadingKey || !issuedName.trim()}
                fullWidth
                sx={{ mb: 2 }}
              >
                {loadingKey ? "Generating..." : "Generate Signup Key"}
              </Button>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleEditClick}>
          <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Edit Limit</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDeleteClick} sx={{ color: "error.main" }}>
          <ListItemIcon><DeleteIcon fontSize="small" color="error" /></ListItemIcon>
          <ListItemText>Delete Key</ListItemText>
        </MenuItem>
      </Menu>
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this key for <b>{selectedRow?.issuedName}</b>?
            Once deleted, new doctors won't be able to use this key for signup.
          </Typography>
          <Box sx={{ display: "flex", gap: 2, mt: 3, justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={() => setDeleteConfirmOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleConfirmDelete}
            >
              Yes, Delete
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog open={openEditModal} onClose={() => setOpenEditModal(false)}>
        <DialogTitle>Update Doctor Key Limit</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography sx={{ fontSize: "14px", mb: 1, fontWeight: 500 }}>
            Set New Max Doctors Limit
          </Typography>
          <input
            type="number"
            value={editMaxUsage}
            onChange={(e) => {
              const val = e.target.value;
              setEditMaxUsage(val === "" ? "" : Number(val));
            }}
            style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
          />
          <Box sx={{ display: "flex", gap: 2, mt: 3, justifyContent: "flex-end" }}>
            <Button onClick={() => setOpenEditModal(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleUpdateLimit}
              sx={{ bgcolor: "#194AF5" }}
            >
              Update
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <ConfirmModal
        open={confirmOpenModal}
        close={() => setconfirmOpenModal(false)}
        confirm={() => {
          handleSave();
          setconfirmOpenModal(false);
        }}
        type={"subscription"}
      />
      <JoinedDoctorsModal
        open={joinedDocsOpen}
        onClose={() => setJoinedDocsOpen(false)}
        selectedKey={selectedRow}
      />
    </Box>
  );
}

export default Settings;
